import Image from 'next/image';

interface Iprops {
  name?: string;
  address: string;
  data?: Record<string, any>;
}

const LocationMap = ({ name, address, data }: Iprops) => {
  const hoursOfOperation = data?.hoursOfOperation
    ?.split('\n')
    .filter((e: any) => e);
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(
    address
  )}&output=embed`;
  return (
    <div className="py-5 mt-2">
      <div
        id="map-wrapper"
        className="px-5 py-10 border-slate-300 rounded-lg border-[1px]"
      >
        <div id="google-map" className="max-h-[350px] h-[340px]">
          <iframe
            title={name}
            src={mapSrc}
            width="100%"
            height="100%"
            loading="lazy"
            className="border-none"
          />
        </div>
        {data?.address && (
          <div id="address" className="flex pt-5">
            <>
              <div
                id="image-wrapper"
                className="flex justify-center items-center "
              >
                <Image
                  src="https://res.cloudinary.com/see-sight-tours/image/upload/v1685546372/Remaining%20images/location_qcm6p4.svg"
                  width={50}
                  height={50}
                  alt="See Sight Tours"
                  priority={true}
                />
              </div>
              <div className="py-2 px-2 text-xl">{data.address}</div>
            </>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationMap;
